import { create } from 'zustand';
import {
    sendTurnos,
    sendTurnosCodes,
    sendTurnosSelected
} from '../channels/turnosChannel';

function sortTurnos(turnos = []) {
    return [...turnos].sort((a, b) =>
        String(a.nome).localeCompare(
            String(b.nome),
            'pt-BR'
        )
    );
}

export const NO_TURNO_ID = 0;

export const NO_TURNO_OPTION = {
    id: NO_TURNO_ID,
    nome: 'Sem Turno'
};

function getTurnosSelecionados() {

    try {

        const saved = localStorage.getItem('turnosSelecionados');

        return saved
            ? JSON.parse(saved)
            : null;

    } catch {

        return null;

    }

}

function saveTurnosSelecionados(turnosSelecionados) {

    try {

        if (turnosSelecionados === null) {

            localStorage.removeItem(
                'turnosSelecionados'
            );

            return;

        }

        localStorage.setItem(
            'turnosSelecionados',
            JSON.stringify(turnosSelecionados)
        );

    } catch {}

}

function buildTurnosState(turnos = []) {

    const sorted = sortTurnos(
        turnos.filter(
            turno => Number(turno.id) > 0
        )
    );

    const turnosComOpcaoSemTurno = [
        NO_TURNO_OPTION,
        ...sorted
    ];

    return {
        turnos: sorted,

        turnosComOpcaoSemTurno,

        turnosMap: new Map(
            turnosComOpcaoSemTurno.map(turno => [
                Number(turno.id),
                turno
            ])
        )
    };

}

const TURNOS_CODES_EXTRAS = {
    ESPECIAL: 'ESP'
};

function normalizeCode(value) {
    return String(value ?? '').trim().toUpperCase();
}

function buildTurnosCodesState(turnosCodes = []) {

    const map = new Map();

    for (const turno of turnosCodes) {

        const code = normalizeCode(turno.code);
        const kmlCode = normalizeCode(turno.kml_code);

        if (!kmlCode) {
            continue;
        }

        if (code) {
            map.set(code, kmlCode);
        }

        map.set(kmlCode, kmlCode);
    }

    // =========================
    // CÓDIGOS EXTRAS
    // =========================

    for (const [code, kmlCode] of Object.entries(TURNOS_CODES_EXTRAS)) {

        if (!map.has(code)) {
            map.set(code, kmlCode);
        }

        if (!map.has(kmlCode)) {
            map.set(kmlCode, kmlCode);
        }
    }

    // =========================
    // ORDENA POR TAMANHO
    // =========================

    const turnosCodesMap = new Map(
        [...map.entries()].sort(
            ([a], [b]) => b.length - a.length
        )
    );

    return {
        turnosCodes,
        turnosCodesMap
    };
}

const initialTurnosSelecionados = getTurnosSelecionados();

export const useTurnosStore = create((set) => ({
    
    turnos: [],

    turnosComOpcaoSemTurno: [
        NO_TURNO_OPTION
    ],

    turnosMap: new Map([
        [NO_TURNO_ID, NO_TURNO_OPTION]
    ]),

    turnosCodes: [],
    turnosCodesMap: new Map(),

    turnosSelecionados: initialTurnosSelecionados,

    setTurnos: (turnos = [], broadcast = true) => {
        set(buildTurnosState(turnos));

        if(broadcast){
            sendTurnos(turnos);
        }
    },

    setTurnosCodes: (turnosCodes = [], broadcast = true) => {
        set(buildTurnosCodesState(turnosCodes));

        if(broadcast){
            sendTurnosCodes(turnosCodes);
        }
    },

    setTurnosSelecionados: (turnosSelecionados, broadcast = true) => {

        saveTurnosSelecionados(turnosSelecionados);

        set({
            turnosSelecionados
        });

        if(broadcast){
            sendTurnosSelected(turnosSelecionados);
        }

    },

    resetTurnos: () =>
        set({
            turnos: [],

            turnosComOpcaoSemTurno: [
                NO_TURNO_OPTION
            ],

            turnosMap: new Map([
                [NO_TURNO_ID, NO_TURNO_OPTION]
            ]),
            
            tunrnosMap: new Map(),
            turnosCodes: [],
            turnosCodesMap: new Map(),
            turnosSelecionados: null,
        })

}));